import { useNavigate } from "react-router-dom";
import { usePictureTopUpStore } from "./store";
import { TopUpContainer, TopUpPageContainer, UserInfoContainer } from "./atom";
import { useInitTabList } from "./hooks/useInitTabList";
import { TopUpTowOrThreeTabs } from "@/components/top-up/components/tabs";
import { PictureUserInfoBar } from "./components/user-info-bar";
import { useGlobalStore } from "@/store/GlobalStore";
import TopAdvertiseModule from "@/components/top-up/components/top-advertise-module";

export function PictureTopUp() {
  const { getTabsList } = useInitTabList();
  const navigate = useNavigate();
  const { activeName, setter } = usePictureTopUpStore();
  const { isZh } = useGlobalStore();
  const tabsList = getTabsList();

  return (
    <TopUpPageContainer>
      {/* 顶部广告 */}
      <TopAdvertiseModule
        activeName={activeName}
        isZh={isZh}
        imageUrlLink={
          getTabsList().find((item) => item.key === activeName)?.advertiseImg
        }
        imageUrlLinkEventDetails={
          getTabsList().find((item) => item.key === activeName)?.advertiseLink
        }
      />
      <TopUpContainer>
        <TopUpTowOrThreeTabs
          // destroyInactiveTabPane 解决使用相同包含svg组件 切换tab时svg不展示
          className={`length-${tabsList.length}`}
          destroyInactiveTabPane
          tabsList={tabsList}
          activeKey={activeName}
          onChange={(k) => {
            setter((state) => {
              state.activeName = k;
            });
            navigate(`/topUp?activeName=${k}`);
          }}
        />
        <UserInfoContainer>
          <PictureUserInfoBar />
        </UserInfoContainer>
      </TopUpContainer>
    </TopUpPageContainer>
  );
}
